<template>
<div>
	<modal-dialog :title="modalTitle"
		:modal-visible="visible"
		confirm-button-text="Save"
		:working="working"
		:submit-visible="userCanWriteEvent"
		v-on:closeModal="$emit('closeModal')"
		v-on:confirm="saveModalEdit">

		<h5>
			<router-link v-if="(record.type == 'project' || record.type == 'service') && (record.Service || record.Job)" :to="
					record.Service ? '/service/'+record.Service.slug+'/dashboard' : '/project/'+record.Job.slug+'/dashboard' 
				">
				{{record.description}}
			</router-link>
			<router-link v-else-if="record.type == 'user' && 'User' in record && record.User" :to="'/employee/'+record.User.slug+'/profile'">
				{{record.description}}
			</router-link>
			<router-link v-else-if="record.type == 'equipment' && 'Equipment' in record && record.Equipment" :to="'/equipment/edit/'+record.Equipment.slug+'/log'">
				{{record.description}}
			</router-link>
			<template v-else>
				{{record.description}}
			</template>
			<div v-if="record.type == 'user' || record.type == 'equipment'"><small>
				<router-link v-if="'Service' in record && record.Service" :to="'/service/'+record.Service.slug+'/dashboard'">
					Service #{{record.Service.job_num}}
				</router-link>
				<router-link v-else-if="'Job' in record && record.Job" :to="'/project/'+record.Job.slug+'/dashboard'">
					Project #{{record.Job.job_num}}
				</router-link>
			</small></div>
		</h5>

		<!--
		<div v-if="record.type == 'equipment'">
			<job-picker
				v-if="!+payload.service_id" 
				label="Assign to Project" 
				col-class="col-md-5" 
				job-type="project"
				v-model="payload.job_id"
				v-on:change="jobChange">
			</job-picker>

			<job-picker
				v-if="!+payload.job_id" 
				label="Assign to Service" 
				col-class="col-md-5" 
				job-type="service"
				v-model="payload.service_id"
				v-on:change="jobChange">
			</job-picker>
		</div>
		-->

		<alert v-if="record.is_vacation == 1 && !record.ApprovedBy" classes="alert-info" message="Pending approval" :unclosable="true" :visible="true"></alert>

		<template v-if="record.type == 'project' || record.type == 'service'">

			<form-group :label="record.type == 'project' ? 'Project Start/End Date' : 'Service Start/End Date'"
				col-class="col-md-5">

				<div class="d-flex">
					<field
						:params="{type:'date'}"	
						:readonly="!userCanWriteEvent"				
						v-model="payload.startDate"
						v-on:change="startDateChange">
					</field>

					<field
						:params="{type: 'date'}"
						:readonly="!userCanWriteEvent"
						v-model="payload.repeat_until"
						v-on:change="repeatUntilChange">
					</field>
				</div>
			</form-group>

			<form-group label="Daily Start/End Time"
				col-class="col-md-5">

				<div class="d-flex">
					<field
						class="flex-grow-1"
						:params="{type:'time'}"
						:readonly="!userCanWriteEvent"
						v-model="payload.startTime"
						v-on:change="startTimeChange">
					</field>

					<field
						class="flex-grow-1"
						:params="{type:'time'}"
						:readonly="!userCanWriteEvent"
						v-model="payload.endTime"
						:invalid="$store.errorList.endTime"
						v-on:change="endTimeChange">
					</field>
				</div>
			</form-group>

			<v-calendar class="mb-3 mt-1"
				:attributes="[
					{
						dates: daysEntityScheduled,
						highlight: true,
					},
					{
						dates: daysEntitySelectedToBeScheduled,
						highlight: true,
					}
				]"
				color="indigo"
				:first-day-of-week="0"
				is-expanded>
			</v-calendar>

			<field label="Days of Week"
				col-class="col-md-5"
				:params="{
					type: 'checklist',
					options: daysOfWeekOptions()
				}"
				:readonly="!userCanWriteEvent"
				v-model="repeatItem.daysOfWeek">
			</field>

			<field v-if="record.type == 'service'"
				label="Pick a lead crew member"
				col-class="col-md-5"
				:params="{
					type: 'select',
					options: userOptions()
				}"
				v-model="assignedLeadCrewMember">
			</field>

			<field label="Assign employees to job"
				col-class="stacked"
				:params="{
					type: 'select-multi',
					options: userOptions()
				}"
				v-model="assignedUsers">
			</field>

		</template>
		<template v-else>

			<field v-if="record.type == 'user' && record.job_id == 0 && record.service_id == 0 && (!record.is_off || record.is_off == 0)"
				class="mb-2"
				label="Type"
				col-class="col-md-2"
				:float-control-right="true"
				:params="{type:'btn-group',buttons: [
					{text:'Vacation',value:'vacation'},
					{text:'Sick Day',value:'sick'},
					{text:'Generic',value:'other'},
				]}"
				:readonly="!userCanWriteEvent"
				v-model="userEventType"
				v-on:change="userEventTypeChange">
			</field>

			<alert v-else-if="record.is_off == 1" classes="alert-warning" icon="fa-ban" :visible="true" :unclosable="true">
				Scheduled OFF
			</alert>
			<!--
			<template v-if="(record.type == 'user' && userEventType == 'assignment') || record.type == 'equipment'">

				<field v-if="!payload.service_id" 
					label="Project" 
					col-class="col-md-4" 
					:params="{type: 'select', options: jobOptions}" 
					v-model="payload.job_id">
				</field>

				<field v-if="!payload.job_id" 
					label="Service" 
					col-class="col-md-4" 
					:params="{type: 'select', options: serviceOptions}" 
					v-model="payload.service_id">
				</field>
			</template>
			-->

			<div>
				<label>
					<input type="checkbox" v-model="allDay" v-on:change="allDayChange">
					Full Day(s)
				</label>
			</div>

			<form-group label="Start Date/Time"
				col-class="col-md-4">

				<div class="d-flex">
					<field
						:params="{type:'date'}"
						:readonly="!userCanWriteEvent"
						v-model="payload.startDate"
						v-on:change="timeChanged">
					</field>

					<field v-if="!allDay"
						:params="{type:'time'}"
						:readonly="!userCanWriteEvent"
						v-model="payload.startTime"
						v-on:change="timeChanged">
					</field>
				</div>
			</form-group>

			<form-group label="End Date/Time"
				col-class="col-md-4">

				<div class="d-flex">
					<field
						:params="{type:'date'}"
						:readonly="!userCanWriteEvent"
						v-model="payload.endDate">
					</field>

					<field v-if="!allDay"
						:params="{type:'time'}"
						:readonly="!userCanWriteEvent"
						v-model="payload.endTime">
					</field>
				</div>
			</form-group>

		</template>

		<template v-if="record.type == 'user' && payload.service_id > 0">
			<field label="Is Lead Technician"
				col-class="col-auto"
				:readonly="!userCanWriteEvent"
				:params="{type:'boolean'}"
				v-model="isLeadTechnician">
			</field>
		</template>

		<field v-if="record.type == 'user' && (payload.service_id > 0 || payload.job_id > 0)" label="Starting Location"
			:readonly="!userCanWriteEvent"
			col-class="col-md-4"
			:params="{type: 'select',options:[
				{text: 'Jobsite', value: 'Jobsite'},
				{text: 'Office', value: 'Office'},
				{text: 'Yard', value: 'Yard'}
			]}"
			v-model="payload.starting_location">
		</field> 

		<!--
		<template v-if="!('id' in record) && (record.type == 'user' || record.type == 'equipment') && (record.service_id > 0 || record.job_id > 0) && parentIsRepeatingEvent">
			<field label="Duplicate to repeated events"
				col-class="col-auto"
				:params="{type:'boolean'}"
				v-model="duplicateToRepeatedEvents">
			</field>
		</template>
		-->

		<field v-if="repeatedEvents.length > 1 && 'id' in record && record.id > 0"
			label="Edit all occurances of this event"
			:readonly="!userCanWriteEvent"
			col-class="col-auto"
			:params="{type:'boolean'}"
			v-model="editAllOccurances">
		</field>

		<field label="Notes"
			:readonly="!userCanWriteEvent"
			col-class="stacked"
			:params="{type: 'textarea'}"
			v-model="payload.notes">
		</field> 

		<div v-if="record && 'ApprovedBy' in record && record.ApprovedBy" class="alert alert-success">Approved by {{record.ApprovedBy.first_name}} {{record.ApprovedBy.last_name}}</div>
		<div v-if="record && 'RejectedBy' in record && record.RejectedBy" class="alert alert-warning">Rejected by {{record.RejectedBy.first_name}} {{record.RejectedBy.last_name}}</div>
		<div v-if="record.approved_by == 0 && record.reject_by == 0" class="alert alert-info">Pending approval</div>

		<template v-if="userCanWriteEvent && record && 'is_vacation' in record && record.is_vacation == 1">
			<template v-if="eventApproved">
				<form-group label="Vacation" col-class="col-md-4">
					<span v-if="'ApprovedBy' in record && record.ApprovedBy"><i class="fa fa-check"></i> Approved by {{record.ApprovedBy.first_name}} {{record.ApprovedBy.last_name}}. </span>
					<a href="#" v-on:click.prevent="approveRejectVacation(record.id,0)">Withdraw approval...</a>
				</form-group>
			</template>
			<form-group v-else label="Vacation Request"
				col-class="col-md-4">
				
				<button class="btn btn btn-success" v-on:click="approveRejectVacation(record.id,1)">
					<i class="fa fa-check"></i>
					Approve...
				</button>
				<button class="btn btn btn-dark" v-on:click="approveRejectVacation(record.id,0)">
					<i class="fa fa-ban"></i>
					Reject...
				</button>

			</form-group>
		</template>

		<template slot="footer">
			<button v-if="mode == 'edit' && userCanWriteEvent" type="button" class="btn btn-outline-danger" v-on:click="deleteItem">
				<i class="fa fa-trash"></i>
				Delete Event
			</button>
		</template>

	</modal-dialog>

	<modal-dialog :modal-visible="deleteModal.visible"
		title="Delete Event"
		confirm-button-text="Confirm Delete"
		button-class="btn-outline-danger"
		v-on:confirm="confirmDeleteEvents"
		v-on:closeModal="deleteModal.visible = false">

		Are you sure you want to delete this event?

		<template>
			<field label="Delete any duplicate repeated events too"
				col-class="col-auto"
				:control-left="true"
				:params="{type:'boolean'}"
				v-model="deleteModal.deleteRelated">
			</field>
		</template>

	</modal-dialog>
</div>
</template>
<script type="text/javascript">

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import VCalendar from "v-calendar/src/components/Calendar"
import Alert from "@/components/Alert"
import JobPicker from "@/components/super_components/JobPicker"


import ScheduleMixins from "@/mixins/ScheduleMixins.js"
	
export default {
	name: "ScheduleEventEditModal",
	components: {
		Field,
		ModalDialog,
		FormGroup,
		VCalendar,
		Alert,
		JobPicker
	},
	mixins: [ScheduleMixins],
	props: [
		"record",
		"scheduleRows",
		"visible",
		"createRecord",
		"projectsOnSchedule",
		"servicesOnSchedule",
	],
	data() {
		return {
			allDay: false,
			payload: {},
			repeatedEvents: [],
			working: false,
			userEventType: null,
			mode: "edit",
			isLeadTechnician: false,
			repeatItem: {
				daysOfWeek: []
			},
			deleteModal: {
				visible: false,
				deleteRelated: false
			},
			scheduleRowsLocal: null,
			eventApproved: false,
			duplicateToRepeatedEvents: false,
			editAllOccurances: false,
			assignedLeadCrewMember: null,
			assignedUsers: []
		}
	},
	watch: {
		record() {
			this.setData()
			this.fetchRepeatedEvents()
		},
		scheduleRows() {
			this.scheduleRowsLocal = this.scheduleRows
		},
		visible() {
			this.editAllOccurances = false
			this.duplicateToRepeatedEvents = false
			this.deleteModal.deleteRelated = false

			if (this.visible) {
				this.assignedUsers = []
				this.assignedLeadCrewMember = null

				this.setData()
				this.fetchData()
			}
		}
	},
	computed: {
		modalTitle() {
			if (this.createRecord)
				return "Add Schedule Event"
			else
				return "Edit Schedule Event"
		},
		userCanWriteEvent() {
			if (this.hasModulePermWrite("Schedule"))
				return true

			if (this.record.user_id == this.$store.userDetails.id && this.record.service_id == 0 && this.record.job_id == 0)
				return true

			return false
		},
		dateRange() {
			return {start: new Date(2022,2,10),end: new Date(2022,2,15)}
		},
		isRepeatingEvent() {
			let vm = this

			return (vm.record.type == 'project' || vm.record.type == 'service') && vm.moment(vm.payload.repeat_until).isAfter(vm.payload.startDate)
		},
		daysEntityScheduled() {
			let days = new Set, vm = this

			this.repeatedEvents.forEach(event => {
				days.add(this.moment(event.start_time).toISOString())
			})

			return [...days]
		},
		//days that the event will be repeated on based on checkbox selections and enddate
		daysEntitySelectedToBeScheduled() {
			let days = new Set, vm = this

			let end = this.moment(this.payload.repeat_until)

			for (var m = this.moment(this.payload.startDate); m.isSameOrBefore(end); m.add(1,"days")) {
				if (vm.repeatItem.daysOfWeek.indexOf(m.day().toString()) >= 0) {

					days.add(this.moment(m).toISOString())
				}
			}

			return [...days]
		},
		parentIsRepeatingEvent() {
			let vm = this
			let parent
			if (this.scheduleRowsLocal) {
				this.scheduleRowsLocal.forEach(row => {
					if ("items" in row && row.items) {
						let key = "job_id"
						if (vm.record.service_id > 0)
							key = "service_id"

						if (!parent) 
							parent = row.items.find(item => item[key] == vm.record[key] && (item.type == 'project' || item.type == 'service'))
					}
				})
			}

			if (parent && vm.moment(parent.repeat_until).isAfter(parent.startMoment))
				return true

			return false
		},
		projectOptionsLocal() {
			return this.optionify(this.projectsOnSchedule.map(job => {
				job.jobNumberAndName = job.job_num +" : " + job.job_name

				return job
			}),"jobNumberAndName")
		},
	},
	methods: {
		endTimeChange(newValue) {
			/*
			// End time cannot be before start time
			if (this.payload.startDate == this.payload.repeat_until &&
				newValue < this.payload.startTime)
			{
				this.payload.startTime = newValue
				this.$forceUpdate()
			}
			*/
		},
		startTimeChange(newValue) {
			if (this.payload.startDate == this.payload.repeat_until &&
				newValue > this.payload.endTime)
			{
				this.payload.endTime = newValue
				this.$forceUpdate()
			}
		},
		repeatUntilChange(newValue) {
			// End date cannot be before start date
			if (newValue < this.payload.startDate)
				this.payload.startDate = newValue
			this.$forceUpdate()
		},
		startDateChange(newValue) {
			if (newValue > this.payload.repeat_until)
				this.payload.repeat_until = newValue
			this.$forceUpdate()
		},
		setData() {
			let vm = this

			this.isLeadTechnician = false

			if (this.record) {

				this.repeatItem.daysOfWeek = []

				this.payload = {
					startDate: "startMoment" in this.record ? this.record.startMoment.local().format("YYYY-MM-DD") : null,
					startTime: "startMoment" in this.record ? this.record.startMoment.local().format("HH:mm") : null,
					endDate: "endMoment" in this.record ? this.record.endMoment.local().format("YYYY-MM-DD") : null,
					endTime: "endMoment" in this.record ? this.record.endMoment.local().format("HH:mm") : null,
				}

				let mapKeys = ["user_id","equipment_id","service_id","job_id","is_sickday","is_vacation","is_off","notes","repeat_until","starting_location"]
				mapKeys.forEach(key => {
					if (key in this.record)
						this.payload[key] = this.record[key]
				})

				if (this.record.type == 'user') {

					if (this.record.is_vacation == 1)
						this.userEventType = 'vacation'
					else if (this.record.is_sickday == 1)
						this.userEventType = 'sick'
					else if (this.record.job_id > 0 || this.record.service_id > 0)
						this.userEventType = 'assignment'
					else
						this.userEventType = 'other'

					if ("Service" in this.record && this.record.Service) {
						if (this.record.Service.assigned_to == this.record.user_id)
							this.isLeadTechnician = true
					}
				}

				if ("ApprovedBy" in this.record && this.record.ApprovedBy)
					this.eventApproved = true
				else
					this.eventApproved = false

				if ("Service" in this.record && this.record.Service) {



					if ("assigned_to" in this.record.Service && this.record.Service.assigned_to > 0) 
						this.assignedLeadCrewMember = this.record.Service.assigned_to
				}

			}
		},
		jobChange(value) {
			this.$forceUpdate()
		},
		daysOfWeekOptions() {
			let options = [
				{text: 'Sunday',value:'0'},
				{text: 'Monday',value:'1'},
				{text: 'Tuesday',value:'2'},
				{text: 'Wednesday',value:'3'},
				{text: 'Thursday',value:'4'},
				{text: 'Friday',value:'5'},
				{text: 'Saturday',value:'6'},
			]

			let endDateMoment = this.moment(this.payload.repeat_until)
			let startDateMoment = this.moment(this.payload.startDate)

			let daysBetweenRange = endDateMoment.diff(this.moment(this.payload.startDate),"days")

			if (daysBetweenRange >= 7)
				return options //all days of week available

			let daysOfWeekInRange = new Set()
			for (var s = this.moment(startDateMoment); s.diff(endDateMoment, 'days') <= 0; s.add(1, 'days')) {
				daysOfWeekInRange.add(s.day())
			}

			daysOfWeekInRange = [...daysOfWeekInRange]

			return options.filter(d => daysOfWeekInRange.indexOf(+d.value) >= 0)
		},
		getKeyFromType(type) {
			let key
			if (type == 'user')
				key = "user_id"
			else if (type == 'equipment')
				key = "equipment_id"
			else if (type == 'project')
				key = "job_id"
			else if (type == 'service')
				key = "service_id"

			return key
		},
		timeChanged() {
			let vm = this

			this.$nextTick(() => {

				let endDateTime = vm.moment(vm.payload.endDate + " " + vm.payload.endTime)

				if (!endDateTime.isValid() || endDateTime.isBefore(vm.moment(vm.payload.startDate + " " + vm.payload.startTime))) 
					//can't be allowed
					vm.payload.endDate = vm.moment(vm.payload.startDate).format("YYYY-MM-DD")
			})
		},
		allDayChange(value) {
			let vm = this

			this.$nextTick(() => {
				if (vm.allDay) {
					vm.payload.startTime = "00:00"
					vm.payload.endTime = "23:59"
				}
			})
		},
		deleteItem() {
			this.deleteModal.visible = true
		},
		confirmDeleteEvents() {
			let vm = this

			this.working = true

			this.postData("ScheduleEvent/delete",{id:vm.record.id,deleteRelated: vm.deleteModal.deleteRelated},true).then(response => {
				vm.working = false

				if (response.success) {
					vm.deleteModal.visible = false

					vm.$emit("scheduleRowsUpdated",vm.scheduleRowsLocal)
					vm.$emit("eventDeleted")
					vm.$emit('closeModal')
				}
				else if ("errors" in response && response.errors.length > 0 && response.errors[0] == "A delete request has been sent to the user") {
					vm.$emit("eventDeleted")
					vm.$emit('closeModal')
					vm.deleteModal.visible = false
				}
			})
		},
		userEventTypeChange(value) {
			if (value != 'assignment') {
				this.payload.service_id = 0
				this.payload.job_id = 0
			}
		},
		saveModalEdit() {
			let vm = this

			// End time cannot be before start time
			if (this.payload.startDate == this.payload.repeat_until &&
				this.payload.endTime < this.payload.startTime) {

				this.$store.errorList.endTime = true
				this.alertFail("Daily end time cannot be before the start time")
				return
			}

			let values = this.payload

			let startTime = values.startTime
			if (!startTime)
				startTime = "00:00"

			let endTime = values.endTime
			if (!endTime)
				endTime = "23:59:59"

			let payload = {
				start_time: this.moment(values.startDate+" "+startTime).utc().format("YYYY-MM-DD HH:mm"),
				notes: this.payload.notes
			}

			if (("user_id" in values && values.user_id > 0) || ("equipment_id" in values && values.equipment_id > 0)) {
				//child entitty
				payload.end_time = this.moment(values.endDate+" "+endTime).utc().format("YYYY-MM-DD HH:mm")
			}
			else {
				//job entity
				let endTimeDate = values.startDate
				//if end time is before start time, roll over the end-time date
				if (this.moment(values.startDate+" "+startTime).isAfter(this.moment(endTimeDate + " " + endTime)))
					endTimeDate = this.moment(endTimeDate).add(1,"days").format("YYYY-MM-DD")

				payload.end_time = this.moment(endTimeDate+" "+endTime).utc().format("YYYY-MM-DD HH:mm")
				payload.repeat_until = values.repeat_until
			}

			let mapKeys = ["user_id","equipment_id","service_id","job_id","event_id","notes","starting_location"]
			mapKeys.forEach(key => {
				if (key in values) 
					payload[key] = values[key]
			})

			//make sure services that are linked to projects (which would have both job_id and service_id set), get the job_id removed
			if ("service_id" in payload && payload.service_id > 0)
				delete payload.job_id

			if (this.record.type == 'user') {
				if (this.userEventType == 'vacation') {
					payload.is_vacation = 1
					payload.is_sickday = 0
				}
				else if (this.userEventType == 'sick') {
					payload.is_vacation = 0
					payload.is_sickday = 1
				}
				else {
					payload.is_vacation = 0
					payload.is_sickday = 0
				}
			}

			if (this.record.type == 'user' && this.payload.service_id > 0)
				payload.isLeadTechnician = this.isLeadTechnician

			if ("id" in this.record && this.record.id)
				payload.id = this.record.id

			this.saveEvent(payload).then(response => {

				if (response.success) {
					vm.$emit('closeModal')

					if (vm.record.type == 'project' || vm.record.type == 'service') {

						//create events for assigned employees & equipment to project
						let childPromises = []

						if (vm.assignedLeadCrewMember > 0) {

							let leadPayload = {
								user_id: vm.assignedLeadCrewMember,
								start_time: payload.start_time,
								end_time: payload.end_time,
								parent_event_id: response.record_id,
								isLeadTechnician: 1
							}

							if ("service_id" in payload)
								leadPayload.service_id = payload.service_id
							if ("job_id" in payload)
								leadPayload.job_id = payload.job_id

							childPromises.push(vm.postData("ScheduleEvent/save",leadPayload))
						}

						vm.assignedUsers.forEach(user_id => {

							if (user_id > 0) {
								let userPayload = {
									user_id,
									start_time: payload.start_time,
									end_time: payload.end_time,
									parent_event_id: response.record_id
								}

								if ("service_id" in payload)
									userPayload.service_id = payload.service_id
								if ("job_id" in payload)
									userPayload.job_id = payload.job_id

								childPromises.push(vm.postData("ScheduleEvent/save",userPayload))
							}
						})

						Promise.all(childPromises).then(responses => {

							let errors = []
							responses.forEach(singleResponse => {
								if (!singleResponse.success) {
									if ("error" in singleResponse)
										errors.push(singleResponse.error)
									else if ("errors" in singleResponse) {
										errors = [
											...errors,
											singleResponse.errors
										]
									}
								}
							})

							if (errors.length > 0)
								vm.alertErrors(errors)

							vm.$emit("eventSaved")
						})
					}

					if (vm.editAllOccurances) {
						let promises = []

						let repeatingPayload = vm.cloneObj(payload)

						vm.repeatedEvents.forEach(event => {
							repeatingPayload.id = event.id
							
							repeatingPayload.start_time = vm.moment(vm.moment(event.start_time).format("YYYY-MM-DD")+" "+values.startTime).utc().format("YYYY-MM-DD HH:mm:ss")
							repeatingPayload.end_time = vm.moment(vm.moment(event.end_time).format("YYYY-MM-DD")+" "+values.endTime).utc().format("YYYY-MM-DD HH:mm:ss")

							promises.push(vm.postData("ScheduleEvent/save",repeatingPayload))
						})

						Promise.all(promises).then(response => {
							vm.$emit("eventSaved")
							vm.alertSaved("All occurances updated")
						})
					}
					else if (vm.isRepeatingEvent) {
						//is a repeating job over multiple days

						//save duplicates 
						//get full event first
						vm.getJSON("ScheduleEvent/find/"+response.data.record_id).then(findResponse => {

							let keepFields = [
								"user_id",
								"job_id",
								"service_id",
								"equipment_id",
								"start_time",
								"end_time",
								"repeat_until",
								"notes"
							]
							let repeatingPayload = {}
							keepFields.forEach(key => {
								repeatingPayload[key] = findResponse.data[key]
							})

							vm.saveRepeatingEvents(
								repeatingPayload,
								vm.repeatItem.daysOfWeek,
								vm.moment(repeatingPayload.start_time),
								vm.moment(repeatingPayload.repeat_until),
								vm.assignedLeadCrewMember,
								vm.assignedUsers
							).then(response => {
								vm.alertSaved("Repeating events created")
								vm.$emit("eventSaved")
							})
						})
					}
					/*
					else if (vm.duplicateToRepeatedEvents) {
						//is a child event that needs to be copied to other repeating parent events
						let job_key = "job_id"
						if (payload.service_id > 0)
							job_key = "service_id"

						let params = {
							filters: [
								[job_key, payload[job_key]],
								["start_time >=",payload.start_time],
								["is_published",0]
							]
						}

						vm.getJSON("ScheduleEvent/get",params).then(response => {
							if (response.success) {
								let promises = []

								//iterate the results, and save a duplicate child event for each one
								response.data.forEach(event => {
									let startDay = vm.moment(event.start_time).format("YYYY-MM-DD")
									let eventStartTime = vm.moment(payload.start_time).format("HH:MM:SS")

									payload.start_time = startDay+" "+eventStartTime

									console.log(payload.start_time,event.start_time)

									//make sure daily start time is not before the parent's start time. This may occur if the start time between the source parent event differs from the duplicated event
									if (vm.moment(payload.start_time).isBefore(vm.moment(event.start_time)))
										payload.start_time = event.start_time

									let endDay = vm.moment(event.end_time).format("YYYY-MM-DD")
									let eventEndTime = vm.moment(event.end_time).format("HH:MM:SS")

									payload.end_time = endDay+" "+eventEndTime

									payload.parent_event_id = event.id

									delete payload.id

									promises.push(vm.postData("ScheduleEvent/save",payload))
								})

								Promise.all(promises).then(responses => {
									vm.$emit("eventSaved")
									vm.alertSaved("Event added to all repeating events")
								})
							}
						})

					}
					*/
					else
						vm.$emit("eventSaved")
				}
			})
		},
		saveRepeatingEvents(eventPayload,daysOfWeek,startMoment,untilMoment,leadUserId,helperUserIds) {
			let day = startMoment

			let vm = this

			let promises = []

			let childEventPayloads = []

			let dayIndex = 0
			while (day.isBefore(untilMoment)) {
				dayIndex++

				day.add(1,"days")

				if (daysOfWeek.indexOf(day.format("d")) >= 0) {

					let payload = vm.cloneObj(eventPayload)

					payload.start_time = vm.moment(eventPayload.start_time).add(dayIndex,"days").format("YYYY-MM-DD HH:mm")
					payload.end_time = vm.moment(eventPayload.end_time).add(dayIndex,"days").format("YYYY-MM-DD HH:mm")

					delete payload.id

					promises.push(this.postData("ScheduleEvent/save",payload))

					let promiseIndex = promises.length - 1

					if (helperUserIds && helperUserIds.length > 0) {

						helperUserIds.forEach(userId => {
							payload.user_id = userId
							delete payload.notes
							
							//we'll need to also set parent_event_id, but need to get the parent event response back first, so set the index to track which parent event to attach to
							payload.promiseIndex = promiseIndex

							childEventPayloads.push(vm.cloneObj(payload))
						})
					}
					if (leadUserId > 0) {
						payload.user_id = leadUserId
						payload.isLeadTechnician = 1
						delete payload.notes

						//we'll need to also set parent_event_id, but need to get the parent event response back first, so set the index to track which parent event to attach to
						payload.promiseIndex = promiseIndex

						childEventPayloads.push(vm.cloneObj(payload))
					}
				}	
			}

			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {

					let childPromises = []

					childEventPayloads.forEach(childPayload => {
						if (childPayload && responses[childPayload.promiseIndex].success) {
							childPayload.parent_event_id = responses[childPayload.promiseIndex].data.record_id
							//delete childPayload.promiseIndex

							childPromises.push(this.postData("ScheduleEvent/save",childPayload))
						}
					})

					Promise.all(childPromises).then(childResponses => {
						resolve(responses)
					})
				})
			})
		},
		fetchData() {
			if (this.record && this.repeatedEvents.length == 0)
				this.fetchRepeatedEvents()

			this.fetchUsers([],false,["first_name","last_name","email"])
		},
		fetchRepeatedEvents() {
			let vm = this

			let key = this.getKeyFromType(this.record.type)

			let filters = []

			if (key) {
				filters.push([key,this.record[key]])
			}

			let params = {}

			//make sure we don't scoop up attached users/equipment as well, we only want projects/services if this is a project/service
			if (this.record.type == 'service' || this.record.type == 'project') {
				filters.push(["user_id",0])
				filters.push(["equipment_id",0])
			}

			if (filters.length > 0)
				params.filters = filters

			return new Promise((resolve,reject) => {
				vm.getJSON("ScheduleEvent/get",params).then(response => {
					if (response.success) 
						vm.repeatedEvents = response.data
				
					resolve(response)
				})
			})
		}
	},
	created() {
		this.scheduleRowsLocal = this.scheduleRows

		if (this.visible) {
			this.setData()

			this.fetchData()
		}
	}
}
</script>